import React, { useState, useEffect, useRef, useContext } from "react";
import tableImage from "../assets/images/table_1.png";
import {
  Select,
  Card,
  Modal,
  Button,
  Table,
  Tag,
  Collapse,
  message,
  Badge,
  Form,
  Input,
  InputNumber,
  Tooltip,
  Divider,
  Checkbox,
  Radio,
} from "antd";
import axios from "axios";
import QRCode from "qrcode.react";
import AccessKeyModal from "./checkAccessKey";
import {
  DeleteOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
  EditOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import OrderReceipt from "./OrderReceipt";
import { io } from "socket.io-client";
import "./TableList.css";
import CloseButton from "../components/CloseButton";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";
import { formatReceiptData, printToKitchen } from "../components/ReceiptData";
import { useCurrency } from "../contexts/ValidationContext";
import { getCurrencySymbol } from "../utils/currencyHelper";
import config from "../config";
import { ModalBlurContext } from "./DefaultLayout";


const TableList = ({
  tablesData,
  table,
  restaurantName,
  imageLogo,
  restaurantAddress,
  sentToKitchen,
  tableOrders, // now passed from Homepage
  settings,
  paymentMethods = [],
}) => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;
  const apiEndUserBaseUrl = config.REACT_APP_ENDUSER_API_BASE_URL;

  const { incrementModal, decrementModal } = useContext(ModalBlurContext);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const { Meta } = Card;
  const [open, setOpen] = useState(false);
  const [orderData, setOrderData] = useState([]);
  // Always use the latest orders from props, not local state
  const orders = Array.isArray(tableOrders) ? tableOrders : [];
  const [tableNumber, setTableNumber] = useState(table.table_number);
  const [editStatus, setEditStatus] = useState(null);
  const [qrVisible, setQrVisible] = useState(false);
  const [taxes, setTaxes] = useState([]);
  const [orderReceiptVisible, setOrderReceiptVisible] = useState(false);
  const [deliveredOrders, setDeliveredOrders] = useState([]);
  const [firstOrderID, setFirstOrderID] = useState(null);
  const [firstOrderIDs, setFirstOrderIDs] = useState({});
  const [currentTick, setCheckCurrentTick] = useState({});
  const [initialCheckArray, setInitialCheckArray] = useState(() => {
    const storedValue = localStorage.getItem("initialCheckArray");
    return storedValue ? JSON.parse(storedValue) : []; // Retrieve the stored array from localStorage
  });
  const [orderReceiptSelectedOrders, setOrderReceiptSelectedOrders] = useState(
    []
  );
  const [show, setShow] = useState(true);
  const [areAllCollapsed, setAreAllCollapsed] = useState(true);
  const [activeKeys, setActiveKeys] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedTableOrders, setSelectedTableOrders] = useState(() => {
    const storedValue = localStorage.getItem("selectedTableOrders");
    try {
      const parsedValue = storedValue ? JSON.parse(storedValue) : [];
      return Array.isArray(parsedValue) ? parsedValue : [];
    } catch {
      return [];
    }
  });
  const [editOrderVisible, setEditOrderVisible] = useState(false);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [order, setOrder] = useState(null);

  //access key
  const accessKeyModalRef = useRef();
  //new selected table no
  const [newSelectedTableModal, setNewSelectedTableModal] = useState(false);
  const [newTableDatas, setNewTableDatas] = useState(
    tablesData.length > 0
      ? tablesData.filter(
        (tableData) => tableData.table_number != table.table_number
      )
      : null
  ); // the one to send to TableList
  const [selectedNewTableNumber, setSelectedNewTableNumber] = useState(
    newTableDatas.length > 0 ? newTableDatas[0].table_number : null
  ); // the one to send to TableList
  const [newTableOpen, setNewTableOpen] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [addOnOrders, setAddOnOrders] = useState([]);
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);
  const [products, setProducts] = useState([]);
  const [subMenu, setSubMenu] = useState([]);
  const { currency } = useCurrency();
  const symbol = getCurrencySymbol(currency);
  const orderReceiptRef = useRef();
  // Remove local settings state
  // const [settings, setSettings] = useState({ deliverDisableToggle: true });

  // Add Here (Deposit)
  const [depositModalVisible, setDepositModalVisible] = useState(false);
  const [depositId, setDepositId] = useState(null);
  const [deposit, setDeposit] = useState("0.00");
  const [depositMethod, setDepositMethod] = useState("Paynow");
  const [depositNote, setDepositNote] = useState("");
  const [hasDeposit, setHasDeposit] = useState(false);
  const [depositKey, setDepositKey] = useState([]);
  const [needCreateDeposit, setNeedCreateDeposit] = useState(false);
  const [showModifyDeposit, setShowModifyDeposit] = useState(false);

  const [QrTableNumber, setQrTableNumber] = useState(table.table_number);
  const [qrUrl, setQrUrl] = useState('');
  const [wifiId, setWifiId] = useState("");
  const [wifiPassword, setWifiPassword] = useState("");

  useEffect(() => {
    setHasDeposit(table.hasDeposit);
    setDeposit(table.deposit.depositAmount);
    setDepositMethod(table.deposit.depositMethod);
  }, []);
  const [availableTableList, setAvailableTableList] = useState(tablesData);

  const handleQrToken = async (tableNum) => {
    const { data } = await axios.post(
      `${apiBaseUrl}/api/tables/getTableOrderUrlToken`,
      { tableNumber: tableNum }
    );
    if (data.token) {
      console.log(tableNumber);
      console.log(data.token);
      const token = data.token;
      return token;
    } else {
      console.log(data.token);
      return null;
    }
  };

  const handleAdminToken = async (userId) => {
    const { data } = await axios.post(
      `${apiBaseUrl}/api/tables/getAdminToken`,
      { userId }
    );
    if (data.token) {
      console.log(data.token);
      const token = data.token;
      return token;
    } else {
      return null;
    }
  };

  const handleEditOrder = (order) => {
    console.log("OOOOOOOOOO", order);
    setCurrentOrder(order);
    setEditOrderVisible(true);
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const { data } = await axios.get(
          `${apiBaseUrl}/api/products/get-product`
        );
        setProducts(data);

        const currentProduct = data.find(
          (product) => product.pid === currentOrder.product.pid
        );
        if (currentProduct) {
          setSubMenu(currentProduct.subMenu);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
        message.error("Failed to fetch products.");
      }
    };

    if (editOrderVisible) {
      fetchProducts();
    }
  }, [editOrderVisible, currentOrder]);

  useEffect(() => {
    localStorage.setItem(
      "selectedTableOrders",
      JSON.stringify(selectedTableOrders)
    );
  }, [selectedTableOrders]);

  const getTotalItems = () => {
    return orders
      .reduce((total, order) => {
        if (Array.isArray(order.order_items)) {
          return (
            total +
            order.order_items.reduce((acc, curr) => {
              return acc + (curr.quantity || 0); // Default to 0 if undefined
            }, 0)
          );
        }
        return total; // If order.result is not an array, return the current total
      }, 0)
      .toFixed(0);
  };
  const totalItems = getTotalItems();

  const handleUpdateOrder = async (order_items, order) => {
    console.log("order_items:", order_items);
    console.log("order:", order);
    // const originalOrderItems = order.find(x=>x._id==order_items._id);
    // Validate input
    if (
      !order_items._id ||
      order_items.quantity < 0 ||
      typeof order_items.quantity !== "number"
    ) {
      message.error("Please provide a valid quantity.");
      Swal.fire({
        icon: "error",
        text: "Please provide a valid quantity.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      setEditOrderVisible(true); // Keep modal open if validation fails
      return;
    }

    if (order_items.remarks && typeof order_items.remarks !== "string") {
      // message.error("Please provide a valid remark.");
      Swal.fire({
        icon: "error",
        text: "Please provide a valid remark.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      setEditOrderVisible(true); // Keep modal open if validation fails
      return;
    }
    // Validate required submenu items
    const requiredGroups = subMenu.filter(
      (item) => item.requirement === "required"
    );
    // console.log("Required Groups:", requiredGroups); // Log required groups

    const reportedGroups = new Set();

    for (const groupItem of requiredGroups) {
      if (reportedGroups.has(groupItem.group)) continue;

      const groupItems = subMenu.filter(
        (item) => item.group === groupItem.group
      );
      const isGroupChecked = groupItems.some((groupItem) => {
        return groupItem.items.some((item) => {
          const isItemSelected = order_items.product.addOns.some((addOn) => {
            return addOn.group === groupItem.group && addOn.name === item.name;
          });
          return isItemSelected;
        });
      });

      if (!isGroupChecked) {
        // message.error(`${groupItem.group} needs to be selected at least once.`);
        Swal.fire({
          icon: "error",
          text: `${groupItem.group} needs to be selected at least once.`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        reportedGroups.add(groupItem.group); // Track group to prevent multiple error messages
        setEditOrderVisible(true); // Keep modal open if group validation fails
        return; // Stop execution if no item is selected in the required group
      }
    }

    try {
      let userId;
      if (settings.isAccessKeyNeeded) {

        const operator = await accessKeyModalRef.current?.show();
        if (!operator) {
          return;
        } else {
          userId = operator?.user?.userId;
        }
      } else {
        userId = localStorage.getItem("userId");
      }

      const payload = {
        _id: order._id,
        orderItems_id: order_items._id,
        quantity: order_items.quantity,
        addOns:
          order_items.product.addOns.map((addOn) => ({
            id: addOn.id,
            name: addOn.name,
            price: addOn.price,
            group: addOn.group,
            printer: addOn.printer,
          })) || [],
        remarks: order_items.remarks,
        voidReason: order_items.void_reason,
        tableNumber,
        logo: imageLogo,
        resName: restaurantName,
        address: restaurantAddress,
        cashierName: currentUser,
        totalItems: totalItems,
        userId: userId,
      };

      const response = await axios.put(
        `${apiBaseUrl}/api/orders/update-order-array`,
        payload
      );

      if (response.status === 200) {
        // message.success("Order item updated successfully!");
        Swal.fire({
          title: "Success",
          text: "Order updated successfully!",
          toast: true,
          icon: "success",
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });

        setAddOnOrders((prev) => [
          ...prev,
          { ...order_items, action: "updated" },
        ]);
        // printNotification(order, order_items,originalOrderItems, "edit");
        getAllOrders(); // Refresh the orders after updating

        setEditOrderVisible(false); // Close modal if update is successful
      } else {
        // message.error(response.data.message || "Failed to update order item.");
        Swal.fire({
          icon: "error",
          text: response.data.message || "Failed to update order.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });

        setEditOrderVisible(true); // Keep modal open if update failed
      }
    } catch (error) {
      // message.error(error.response?.data?.message || "Something went wrong while updating the order item.");
      Swal.fire({
        icon: "error",
        text:
          error.response?.data?.message ||
          "Something went wrong while updating the order.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      setEditOrderVisible(true); // Keep modal open if an error occurred
    }
  };


  useEffect(() => {
    const auth = JSON.parse(localStorage.getItem("auth"));
    if (auth) {
      const { token } = auth;
      try {
        const decoded = jwtDecode(token);
        setCurrentUser(decoded.userId);
        if (window.location.pathname === "/login") {
          navigate("/");
        }
      } catch (err) {
        console.error("Invalid token", err);
        localStorage.removeItem("auth");
        navigate("/login");
      }
    } else {
      navigate("/login");
    }
  }, [navigate]);

  const printQrCode = async (tableNumber) => {
    const selectedPrinterId = localStorage.getItem("selectedPrinterId");
    console.log("selectedPrinterId in printQrCode: ", selectedPrinterId);

    try {
      // Prepare qrCodeRequest for backend
      const qrCodeRequest = {
        logo: imageLogo,
        resName: restaurantName,
        address: restaurantAddress,
        URL: `${apiEndUserBaseUrl}/shop?table=${table.table_number}`,
        tableNumber,
        selectedPrinterId: selectedPrinterId,
        wifiId: wifiId,
        wifiPassword: wifiPassword,
      };

      // Send the payload to the backend API
      const response = await axios.post(
        `${config.REACT_APP_API_BASE_URL}/api/printqrcode`,
        qrCodeRequest,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${JSON.parse(localStorage.getItem("auth")).token
              }`,
          },
        }
      );

      if (response.data.success) {
        message.success("QR Code sent to printer successfully!");
      } else {
        throw new Error(response.data.message || "Printing failed");
      }
    } catch (error) {
      console.error("Printing error:", error);
      message.error(
        "Failed to send notification for printing: " +
        (error.response?.data?.message || error.message)
      );
    }
  };

  const printSingleItem = (order, record) => {
    let tempOrder = order;
    const selectedOrderWithSingleItem = order.order_items.find(
      (item) => item._id == record._id
    );
    tempOrder = tempOrder.order_items.find((item) => item._id == record._id);
    localStorage.setItem("selectedTableOrders", JSON.stringify(order.oid));
    localStorage.setItem(
      "selectedSingleRecord",
      JSON.stringify(selectedOrderWithSingleItem)
    );
    setOrderReceiptSelectedOrders([order.oid]);
    setSelectedTableOrders([order.oid]);
    setOrderReceiptVisible(true); // This makes the modal visible
  };

  const printNotification = async (order, order_items, originalOrderItems, actionType) => {
    try {
      // Flatten the tableOrders and check if any order's _id matches the order's _id
      const matchingOrder = tableOrders
        .flat() // Flatten nested arrays
        .find((entry) => entry && entry._id === order._id); // Find order with matching _id

      if (!matchingOrder) {
        console.error("No matching order found.");
        return;
      }

      // Consolidate order_items by grouping them based on product name and remarks
      const consolidateItems = (items) => {
        const consolidated = items.reduce((acc, item) => {
          //const key = `${item.product.name}__${item.remarks || ""}`;
          const key = `${item.product.name}__${item.product.slug}__${item.remarks || ""}__${item.product.addOns || ""
            }`;
          if (!acc[key]) {
            acc[key] = { ...item, quantity: item.quantity };
          } else {
            acc[key].quantity += item.quantity;
          }
          return acc;
        }, {});
        return Object.values(consolidated); // Convert object back to array
      };

      const consolidatedItems = consolidateItems([order_items]); // Consolidate order_items array
      const selectedPrinterId = localStorage.getItem("selectedPrinterId");

      // Prepare payload for backend
      const payload = {
        logo: imageLogo,
        resName: restaurantName,
        address: restaurantAddress,
        tableNumber,
        cashierName: currentUser,
        actionType,
        orderId: matchingOrder.oid,
        items: consolidatedItems.map((item) => ({
          quantity: item.quantity,
          name: item.product.name,
          slug: item.product?.slug,
          addOn: item.product.addOns,

          remarks: item.remarks || "",
        })),
        originalOrderItems,
        timestamp: new Date().toLocaleString(),
        selectedPrinterId: selectedPrinterId,
        isSubmenuPrint: matchingOrder.isSubMenuPrint || false,
      };

      console.log(
        "Sending payload to backend for printing:??????????????",
        payload
      );

      // Send the payload to the backend API
      const response = await axios.post(
        `${config.REACT_APP_API_BASE_URL}/api/printnotification`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${JSON.parse(localStorage.getItem("auth")).token
              }`,
          },
        }
      );

      if (response.data.success) {
        message.success("Notification sent to printer successfully!");
      } else {
        throw new Error(response.data.message || "Printing failed");
      }
    } catch (error) {
      console.error("Printing error:", error);
      message.error(
        "Failed to send notification for printing: " +
        (error.response?.data?.message || error.message)
      );
    }
  };

  const validateQuantity = () => {
    if (!currentOrder) {
      return {
        validateStatus: "error",
        errorMsg: "Order data is missing.",
      };
    }

    const quantity = currentOrder.quantity;

    // Immediate validation for invalid values (non-numbers or <= 0)
    if (quantity <= 0 || typeof quantity !== "number") {
      return {
        validateStatus: "error",
        errorMsg: "Please input the right quantity!",
      };
    }

    // Delay validation for null until form submission
    if (quantity === null && isSubmitted) {
      return {
        validateStatus: "error",
        errorMsg: "Please input the right quantity!",
      };
    }

    return {
      validateStatus: "success",
      errorMsg: null,
    };
  };

  const { validateStatus, errorMsg } = validateQuantity();

  // Modify getAllOrders to handle both initial load and polling updates
  const getAllOrders = () => {
    try {
      const { data } = axios.get(`${apiBaseUrl}/api/orders/get-order`);
      setOrderData(data);
      // console.log('Orders data refreshed');
    } catch (error) {
      console.log(error);
    }
  };

  const onChange = (key) => {
    // console.log('onChange key:',key);
  };

  // useEffect(() => {
  //   // const socket = io("http://localhost:8080");
  //   let socketUrl;
  //   // try {
  //   // socketUrl = new URL(apiBaseUrl).host;
  //   // } catch {
  //       socketUrl = apiBaseUrl;
  //   // }

  //   const socket = io(socketUrl);

  //   socket.on("newOrder", (order) => {
  //     fetchData(order.order_tablenumber);
  //     fetchTableOrders();
  //   });

  //   return () => socket.disconnect();
  // }, []);

  //TODO: move the polling into home page
  // useEffect(() => {
  //   // fetchTaxes();
  //   fetchTableOrders();

  //   // Set up polling
  //   const intervalId = setInterval(() => {
  //     fetchTableOrders();
  //     // fetchTaxes();
  //   }, 7000); // 5000 milliseconds = 5 seconds

  //   // Clear the interval on component unmount
  //   return () => clearInterval(intervalId);
  // }, [tableNumber]);

  //TODO: move the fetch data into hompage
  // useEffect(() => {
  //   fetchData(table.table_number);
  // }, [fetchData, table.table_number]);

  const printDepositChip = async () => {
    try {
      const response = await axios.post(`${apiBaseUrl}/api/printDeposit`, {
        tableNumber,
        cashierName: currentUser,
        depositAmount: deposit,
        depositMethod,
        depositNote,
        selectedPrinterId: localStorage.getItem("selectedPrinterId"),
      });
      if (response.data.success) {
        message.success("Deposit chit sent to printer successfully!");
      } else {
        throw new Error(response.data.message || "Printing failed");
      }
    } catch (error) {
      console.error("Error printing deposit chit:", error);
      message.error("Failed to print deposit chit.");
    }
  };

  const printVoidDepositChip = async (operator, tableNumber, deposit, depositMethod, depositNote) => {
    try {
      const response = await axios.post(`${apiBaseUrl}/api/printvoiddeposit`, {
        tableNumber: tableNumber,
        cashierName: operator,
        depositAmount: deposit,
        depositMethod: depositMethod,
        depositNote: depositNote,
        selectedPrinterId: localStorage.getItem("selectedPrinterId"),
      });
      if (response.data.success) {
        message.success("Void deposit chit sent to printer successfully!");
      } else {
        throw new Error(response.data.message || "Printing failed");
      }
    } catch (error) {
      console.error("Error printing void deposit chit:", error);
      message.error("Failed to print void deposit chit.");
    }
  };

  const fetchTaxes = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/api/taxes/get-taxes`);
      setTaxes(response.data); // Assuming the API returns an array of tax objects
    } catch (error) {
      console.error("Error fetching taxes:", error);
      message.error("Failed to fetch taxes.");
    }
  };

  const handleCancel = () => {
    setOpen(false);
    const currentPath = window.location.pathname;
    const newUrl = `${currentPath}?table=${table.table_number}`;
    window.history.replaceState({}, "", newUrl);
  };

  const showModal = () => {
    fetchTaxes(); // Fetch taxes when opening the modal
    setOpen(true);
    localStorage.setItem("selectedSingleRecord", null);
    localStorage.setItem("selectedTableOrders", []);
  };

  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };

  const filterOrdersByTableNumber = () => {
    // Filter orders where table numbers match
    const filteredOrders = orders;
    // Map the filtered orders to extract their IDs
    const orderIds = filteredOrders.map((order) => order.oid);
    return orderIds;
  };

  const filterBySelectedTableOrders = (selectedOrder) => {
    // selectedOrder: array of oid
    // orders: array of order objects with .oid
    if (!Array.isArray(selectedOrder) || !Array.isArray(orders)) return [];
    const matchedOrders = orders.filter(order => selectedOrder.includes(order.oid));
    // Check if all selected orders are in 'Kitchen' status
    const notInKitchen = matchedOrders.find(order => order.order_progressstatus !== 'Kitchen');
    if (notInKitchen) {
      return false
    }
    return true;
  };

  const handleEditOrderStatus = async (status, orderIds) => {
    try {
      // Retain only the selected orders that match orderIds
      const choosenIds = selectedTableOrders.filter((orderId) =>
        orderIds.includes(orderId)
      );
      // console.log("ChooseId:", choosenIds);

      if (choosenIds.length === 0) {
        console.warn("No matching orders found for the given table.");
        return;
      }

      // Map the chosen IDs to prepare the orders to update
      const ordersToUpdate = choosenIds.map((choosenId) => ({
        orderId: choosenId,
        order_progressstatus: status,
      }));
      // console.log("See this first:",ordersToUpdate);

      if (ordersToUpdate.length === 0) {
        console.warn("No orders selected for updating.");
        return;
      }

      const response = await axios.put(`${apiBaseUrl}/api/orders/edit-order`, {
        orders: ordersToUpdate,
      });

      if (response.status === 200) {
        console.log("Orders updated successfully");
        // Add delivered orders to state
        setDeliveredOrders((prev) => [...prev, ...selectedTableOrders]);

        Swal.fire({
          title: "Success",
          text: "Order status updated successfully",
          toast: true,
          icon: "success",
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });

        // Optionally refresh the page or update the orders list
        // window.location.reload();
        const url = config.REACT_APP_API_BASE_URL;
        window.history.replaceState({}, "", url);
      } else {
        console.error("Some orders failed to update");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleEditOrderStatusKitchen = async (status, orderIds) => {
    try {
      console.log("Updating order status to:", status, "for orders:", orderIds);

      // Directly use the provided orderIds without filtering through selectedTableOrders
      const ordersToUpdate = orderIds.map((orderId) => ({
        orderId: orderId,
        order_progressstatus: status,
      }));

      if (ordersToUpdate.length === 0) {
        console.warn("No orders to update.");
        return;
      }

      console.log("Sending update request for orders:", ordersToUpdate);

      // Send a single request with the orders array
      const response = await axios.put(`${apiBaseUrl}/api/orders/edit-order`, {
        orders: ordersToUpdate,
      });

      if (response.status === 200) {
        console.log("Orders updated successfully");
        // Update the local state to reflect the changes
        setSelectedTableOrders(prev => {
          const newSelection = [...prev, ...orderIds];
          return [...new Set(newSelection)]; // Remove duplicates
        });
      } else {
        console.error("Some orders failed to update");
        throw new Error("Failed to update orders");
      }
    } catch (error) {
      console.error("Error updating order status:", error);
      throw error; // Propagate error to be handled by caller
    }
  };

  const handleEditOneOrderStatus = async (value, status) => {
    try {
      await axios
        .put(`/api/orders/edit-order`, {
          orderArrayId: value._id,
          order_progressstatus: status,
        })
        .then((response) => {
          // console.log(response.data);
          message.success("Order Updated Successfully!");
          setEditStatus(null);
        })
        .catch((error) => {
          console.log(error);
          message.error("Something went wrong!");
        });
    } catch (error) {
      console.log(error);
      message.error("Something went wrong!");
    }
  };

  const handleDeleteOrder = async (order, order_items, reason) => {
    try {
      let userId;
      if (settings.isAccessKeyNeeded) {

        const operator = await accessKeyModalRef.current?.show();
        if (!operator) {
          return;
        } else {
          userId = operator?.user?.userId;
        }
      } else {
        userId = localStorage.getItem("userId");
      }

      console.log('userId: ', userId);
      // Delete order first
      await axios.post(`${apiBaseUrl}/api/orders/delete-order`, {
        orderId: order._id,
        orderItems_id: order_items._id,
        currentUser: userId,
        voidReason: reason,
        userId: userId,
      });
      console.log('order in line 832: ', order);
      // Ask user if they want to print void notification
      const { isConfirmed } = await Swal.fire({
        title: 'Print Void Notification?',
        text: 'Would you like to print a void notification for this order?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, print',
        cancelButtonText: 'No',
      });
      if (isConfirmed) {
        // Prepare notification print payload
        const payload = {
          tableNumber: order.order_tablenumber,
          cashierName: userId || '',
          actionType: 'void',
          orderId: order.oid,
          items: [order_items],
          timestamp: new Date().toISOString(),
          selectedPrinterId: localStorage.getItem('selectedPrinterId'),
        };
        // Try to print notification to all relevant printers
        let printSuccess = false;
        try {
          const resp = await axios.post(`${apiBaseUrl}/api/printers/print-notification-slug`, payload);
          printSuccess = resp.data && resp.data.success;
        } catch (err) {
          printSuccess = false;
        }
        if (printSuccess) {
          Swal.fire({
            title: 'Success',
            text: 'Order Voided & Notification Printed Successfully',
            toast: true,
            icon: 'success',
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
          setAddOnOrders((prev) => [...prev, { ...order_items, action: 'canceled' }]);
          getAllOrders();
        } else {
          // Print failed, ask user what to do
          const { value: action } = await Swal.fire({
            title: 'Print Failed',
            text: 'Notification print failed. What would you like to do?',
            icon: 'error',
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonText: 'Reprint',
            denyButtonText: 'Update Status',
            cancelButtonText: 'Cancel',
          });
          if (action === true) {
            // Reprint
            return await handleDeleteOrder(order, order_items, reason);
          } else if (action === false) {
            // Update status anyway
            Swal.fire({
              title: 'Success',
              text: 'Order Voided (Print Failed)',
              toast: true,
              icon: 'success',
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
            });
            setAddOnOrders((prev) => [...prev, { ...order_items, action: 'canceled' }]);
            getAllOrders();
          } // else Cancel: do nothing
        }
      } else {
        // User chose not to print
        Swal.fire({
          title: 'Success',
          text: 'Order Voided Successfully',
          toast: true,
          icon: 'success',
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        setAddOnOrders((prev) => [...prev, { ...order_items, action: 'canceled' }]);
        getAllOrders();
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Failed to delete order. Please try again.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  const handleCheckoutClick = async (tableNumber) => {
    try {
      // const currentPath = window.location.pathname.replace(/\/$/, "");
      // const newUrl = `${currentPath}/bills?table=${table.table_number}`;
      // window.location.hash = `/bills?table=${tableNumber}`;
      navigate(`/cashiers?table=${tableNumber}`);
    } catch (error) {
      console.error("Error updating the order status:", error);
      message.error("Failed to update order status.");
    }
  };

  const orderReceiptClick = () => {
    try {
      const filteredOrders = selectedTableOrders.filter((oid) => {
        const order = orders.find((order) => order.oid === oid);
        return (
          order?.order_progressstatus === "" ||
          order?.order_progressstatus === "Kitchen"
        );
      });
      setOrderReceiptSelectedOrders(filteredOrders);
      setOrderReceiptVisible(true); // This makes the modal visible
      // console.log('Receipt Modal should be visible now.');
    } catch (error) {
      console.error("Error showing receipt modal:", error);
      message.error("Failed to show receipt modal.");
    }
  };

  const calculateTotalWithTaxes = (order) => {
    const totalWithoutTax = order.order_items.reduce(
      (acc, curr) => acc + curr.product.price * curr.quantity,
      0
    );
    const totalTax = taxes.reduce(
      (acc, tax) => acc + totalWithoutTax * (tax.rate / 100),
      0
    );
    return (totalWithoutTax + totalTax).toFixed(2);
  };

  const calculateTotalWithoutTaxes = (order) => {
    const totalWithoutTax = order.order_items.reduce(
      (acc, curr) => acc + curr.product.price * curr.quantity,
      0
    );

    return totalWithoutTax.toFixed(2);
  };

  const { Panel } = Collapse;

  // const showQrModal = () => {
  //   setQrVisible(true);
  // };
  const showQrModal = async (table_number) => {
    getWifiId();

    let QrTableNumber = tableNumber;
    if (table_number) {
      setQrTableNumber(table_number);
      QrTableNumber = table_number;
    }

    console.log("QrTableNumber:", QrTableNumber);
    const token = await handleQrToken(QrTableNumber);
    if (token) {
      // Construct the full URL with the new token
      const fullUrl = `${apiEndUserBaseUrl}/shop?table=${QrTableNumber}&token=${token}`;
      setQrUrl(fullUrl);
      setQrVisible(true);
    } else {
      console.error("Failed to generate QR token.");
    }
  };

  const hideQrModal = () => {
    setQrVisible(false);
  };

  const handleCheckboxChange = (event, orderId) => {
    setSelectedTableOrders((prevOrders) => {
      const safePrevOrders = Array.isArray(prevOrders) ? prevOrders : [];
      let updatedOrders;
      let updatedActiveKeys;
      if (event.target.checked) {
        // Check: add to selected and open panel
        updatedOrders = [...new Set([...safePrevOrders, orderId])];
        updatedActiveKeys = [...new Set([...activeKeys, orderId])];
      } else {
        // Uncheck: remove from selected and close panel
        updatedOrders = safePrevOrders.filter((id) => id !== orderId);
        updatedActiveKeys = activeKeys.filter((key) => key !== orderId);
      }
      setActiveKeys(updatedActiveKeys);
      localStorage.setItem("selectedTableOrders", JSON.stringify(updatedOrders));
      return updatedOrders;
    });
  };

  const handleSelectAll = () => {
    localStorage.setItem("selectedTableOrders", null);
    // Get all orders for the current table number
    const tableOrdersForCurrentTable = orders;

    // Get the currently selected orders from localStorage
    const storedSelectedOrders =
      JSON.parse(localStorage.getItem("selectedTableOrders")) || [];

    // Extract the IDs of the orders to be selected
    const allOrderIds = tableOrdersForCurrentTable.map((order) => order.oid);

    // Merge the selected orders with previously selected ones, ensuring no duplicates
    const updatedSelectedOrders = [
      ...new Set([
        ...storedSelectedOrders, // Existing selected orders
        ...allOrderIds, // Newly selected orders for the current table
      ]),
    ];

    // Update the selected orders state and localStorage
    setSelectedTableOrders(updatedSelectedOrders);
    localStorage.setItem(
      "selectedTableOrders",
      JSON.stringify(updatedSelectedOrders)
    );
  };

  const handleDeselectAll = () => {
    localStorage.setItem("selectedTableOrders", null);

    // Get the currently selected orders from localStorage
    const storedSelectedOrders =
      JSON.parse(localStorage.getItem("selectedTableOrders")) || [];

    // Get all orders for the current table number
    const tableOrdersForCurrentTable = orders;

    // Extract the IDs of the orders to be deselected
    const allOrderIds = tableOrdersForCurrentTable.map((order) => order.oid);

    // Remove the current table's orders from the selected orders
    const updatedSelectedOrders = storedSelectedOrders.filter(
      (orderId) => !allOrderIds.includes(orderId)
    );

    // Update the selected orders state and localStorage
    setSelectedTableOrders(updatedSelectedOrders);
    localStorage.setItem(
      "selectedTableOrders",
      JSON.stringify(updatedSelectedOrders)
    );
  };

  // useEffect(() => {
  //   fetchTableOrders();
  // }, [table.table_number]);

  const statusBadge = (status) => {
    let color;
    switch (status) {
      case "Kitchen":
        color = "yellow";
        break;
      case "Receive":
        color = "green";
        break;
      case "Preparing":
        color = "blue";
        break;
      default:
        color = "gray";
    }
    return <Badge.Ribbon color={color} text={status} />;
  };

  const calculateOrderCounts = (orders) => {
    let countOrder = 0;
    let countKitchen = 0;
    let countDelivered = 0;

    orders.forEach((order) => {
      if (order.order_progressstatus === "") {
        countOrder += 1;
      }
      if (order.order_progressstatus === "Kitchen") {
        countKitchen += 1;
      }
      if (order.order_progressstatus === "Receive") {
        countDelivered += 1;
      }
    });

    return { countOrder, countKitchen, countDelivered };
  };

  // Calculate badge values
  const { countOrder, countKitchen, countDelivered } = calculateOrderCounts(orders);
  // const isBusy = table.table_status && Array.isArray(tableOrders[table.table_number]) && tableOrders[table.table_number].some(order => order.order_status && order.order_voidstatus != true);
  const isBusy = table.table_status && tableOrders.some(order => order.order_status && order.order_voidstatus !== true);


  const getBadgeStyle = (count, color) => {
    return {
      backgroundColor: count > 0 ? color : "#d9d9d9", // Grey color for count 0
    };
  };

  const handleCollapseToggle = () => {
    setAreAllCollapsed((prev) => {
      const next = !prev;
      if (next) {
        setActiveKeys([]);
      } else {
        setActiveKeys(orders.map((order) => order.oid));
      }
      return next;
    });
  };

  const handlePanelChange = (keys) => {
    setActiveKeys(keys); // Update active keys when individual panels are toggled
  };

  const voidEntireOrderConfirmation = async (orderId) => {
    // Build voidReasonOptions with all 'Other' at the bottom, prefix keys with 'r_'
    let voidReasons = Array.isArray(settings.voidReasons) ? [...settings.voidReasons] : [];
    const otherReasons = voidReasons.filter(r => r.reason.trim().toLowerCase() === 'other');
    voidReasons = voidReasons.filter(r => r.reason.trim().toLowerCase() !== 'other');
    voidReasons = [...voidReasons, ...otherReasons];
    const voidReasonOptions = {};
    voidReasons.forEach(r => { voidReasonOptions[`r_${r.id}`] = r.reason; });
    const { value: voidReasonResult, isConfirmed } = await Swal.fire({
      title: "Warning",
      text: "Are you sure you want to void this order?",
      input: "select",
      inputLabel: "Reason for voiding",
      inputOptions: voidReasonOptions,
      inputPlaceholder: "Select a reason",
      inputValidator: (value) => {
        if (!value) {
          return "You must select a reason!";
        }
      },
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Void Order",
      cancelButtonText: "Cancel",
      preConfirm: async (selectedKey) => {
        const selectedId = selectedKey.startsWith('r_') ? selectedKey.slice(2) : selectedKey;
        const selectedReason = voidReasons.find(r => r.id === selectedId);
        if (selectedReason && selectedReason.reason.trim().toLowerCase() === 'other') {
          const { value: remark, isConfirmed: isOtherConfirmed } = await Swal.fire({
            title: "Other Reason",
            input: "text",
            inputLabel: "Please specify the reason (optional)",
            inputPlaceholder: "Enter your reason",
            showCancelButton: true,
            confirmButtonText: "OK",
          });
          if (!isOtherConfirmed) return false; // Cancel closes all
          return { id: selectedId, text: remark ? remark : selectedReason.reason };
        }
        return { id: selectedId, text: selectedReason?.reason || "" };
      }
    });

    if (isConfirmed && voidReasonResult && voidReasonResult.text) {
      voidEntireOrder(orderId, voidReasonResult.text);
    }
  };

  const voidEntireOrder = async (orderId, voidReason) => {
    try {
      let userId;
      if (settings.isAccessKeyNeeded) {

        const operator = await accessKeyModalRef.current?.show();
        if (!operator) {
          return;
        } else {
          userId = operator?.user?.userId;
        }
      } else {
        userId = localStorage.getItem("userId");
      }

      console.log('userId: ', userId);
      // Void order first (but do not update UI until print step below)
      const response = await fetch(
        `${apiBaseUrl}/api/orders/void-entire-order`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${JSON.parse(localStorage.getItem('auth')).token}`,
          },
          body: JSON.stringify({
            orderId,
            currentUser: userId,
            voidReason,
            userId,
          }),
        }
      );
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.message || 'Network response was not ok');
      }
      // Find the order object (to get table number and items)
      const order = orders.find((o) => o._id === orderId);
      console.log('order in line 1160: ', order);
      // Ask user if they want to print void notification
      const { isConfirmed } = await Swal.fire({
        title: 'Print Void Notification?',
        text: 'Would you like to print a void notification for this order?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, print',
        cancelButtonText: 'No',
      });
      if (!isConfirmed) {
        // User chose not to print
        Swal.fire({
          title: 'Success',
          text: 'The order has been voided successfully.',
          toast: true,
          icon: 'success',
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        if (typeof getAllOrders === 'function') getAllOrders();
        return;
      }
      // Prepare notification print payload
      const payload = {
        tableNumber: order.order_tablenumber || '',
        cashierName: userId || '',
        actionType: 'void',
        orderId: order?.oid,
        items: order?.order_items || [],
        timestamp: new Date().toISOString(),
        selectedPrinterId: localStorage.getItem('selectedPrinterId'),
      };
      let printSuccess = false;
      try {
        const resp = await axios.post(`${apiBaseUrl}/api/printers/print-notification-slug`, payload);
        printSuccess = resp.data && resp.data.success;
      } catch (err) {
        printSuccess = false;
      }
      if (printSuccess) {
        Swal.fire({
          title: 'Success',
          text: 'The order has been voided and notification printed.',
          toast: true,
          icon: 'success',
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        // Only now update status/UI
        if (typeof getAllOrders === 'function') getAllOrders();
      } else {
        // Print failed, ask user what to do
        const { value: action } = await Swal.fire({
          title: 'Print Failed',
          text: 'Notification print failed. What would you like to do?',
          icon: 'error',
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: 'Reprint',
          denyButtonText: 'Update Status',
          cancelButtonText: 'Cancel',
        });
        if (action === true) {
          // Reprint
          return await voidEntireOrder(orderId, voidReason);
        } else if (action === false) {
          // User confirms to update status anyway
          Swal.fire({
            title: 'Success',
            text: 'The order has been voided (Print Failed).',
            toast: true,
            icon: 'success',
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
          });
          if (typeof getAllOrders === 'function') getAllOrders();
        } // else Cancel: do nothing
      }
    } catch (error) {
      Swal.fire({
        title: 'Network Error!',
        text: 'Could not connect to server',
        icon: 'error',
      });
      console.error('Error:', error);
    }
  };

  // Remove local settings fetching
  // const fetchSettings = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${apiBaseUrl}/api/settings/get-settings`
  //     );
  //     // setSettings(response.data);
  //     const { deliverDisableToggle } = response.data;

  //     setSettings({ deliverDisableToggle });
  //   } catch (error) {
  //     console.error("Error fetching settings:", error);
  //     // Set default values if the fetch fails
  //     setSettings({ deliverDisableToggle: false }); // Default value
  //   }
  // };
  // useEffect(() => {
  //   fetchSettings(); // Fetch settings when component mounts
  // }, []);

  // Add Here (Deposit)
  const getDeposit = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/api/deposit/get-deposit`);
      if (response.status === 200) {
        if (response.data.length === 0) {
          setNeedCreateDeposit(true);
        } else {
          const roundedDeposit = parseFloat(
            response.data[0].depositAmount
          ).toFixed(2);
          setDeposit(roundedDeposit);
          setDepositMethod(response.data[0].depositMethod);
          setDepositId(response.data[0]._id);
        }
        setDepositModalVisible(true);
      } else {
        console.error("Failed to get deposit:", response.data);
      }
    } catch (error) {
      console.error("Error updating deposit:", error);
    }
  };

  const showDepositModal = () => {
    getDeposit();
    setDepositNote("");
  };

  const hideDepositModal = () => {
    setDepositModalVisible(false);
  };

  const confirmDeposit = async () => {
    try {
      let userId;
      if (settings.isAccessKeyNeeded) {

        const operator = await accessKeyModalRef.current?.show();
        if (!operator) {
          return;
        } else {
          userId = operator?.user?.userId;
        }
      } else {
        userId = localStorage.getItem("userId");
      }

      console.log('userId: ', userId);

      const payload = {
        tableId: table._id,
        hasDeposit: true,
        deposit: {
          depositAmount: deposit,
          depositMethod: depositMethod,
          depositNote: depositNote.trim(),
        },
      };

      const response = await axios.put(
        `${apiBaseUrl}/api/tables/edit-table`,
        payload
      );

      if (response.status === 200) {
        setHasDeposit(true);
        hideDepositModal();
      } else {
        console.error("Failed to update table:", response.data);
      }
    } catch (error) {
      console.error("Error updating table:", error);
    }
  };

  const relocateTable = async () => {
    console.log("table: ", table);

    try {
      let userId;
      if (settings.isAccessKeyNeeded) {

        const operator = await accessKeyModalRef.current?.show();
        if (!operator) {
          return;
        } else {
          userId = operator?.user?.userId;
        }
      } else {
        userId = localStorage.getItem("userId");
      }

      console.log('userId: ', userId);
      let selectedIds = [];

      console.log("selectedTableOrders in line 1378: ", selectedTableOrders);
      console.log("tableOrders before filtering:", orders);
      orders.forEach((order) => {
        console.log("order in line 1381: ", order);
        if (selectedTableOrders.includes(order.oid)) {
          selectedIds.push(order._id);
        }
      });
      const payload = {
        _ids: selectedIds,
        order_tablenumber: tableNumber,
        newTablenumber: selectedNewTableNumber,
      };
      console.log("payload in line 1388: ", payload);

      const response = await axios.post(
        `${apiBaseUrl}/api/orders/switch-table`,
        payload
      );

      if (response.status !== 200) {
        console.error("Failed to update orders:", response.data);
        return;
      } else {
        showQrModal(selectedNewTableNumber);
      }

      const removeDeposit = {
        tableId: table._id,
        hasDeposit: false,
        deposit: {
          depositAmount: "0.00",
          depositMethod: "Paynow",
          depositNote: "",
        },
      };

      const removeDepositResponse = await axios.put(
        `${apiBaseUrl}/api/tables/edit-table`,
        removeDeposit
      );
      console.log("removeDepositResponse", removeDepositResponse);

      const newTableId =
        tablesData.find(
          (table) => table.table_number === selectedNewTableNumber
        )?._id || null;

      // Only transfer deposit if the original table had a deposit > 0
      if (hasDeposit && parseFloat(deposit) > 0) {
        const addDeposit = {
          tableId: newTableId,
          hasDeposit: true,
          deposit: {
            depositAmount: deposit,
            depositMethod: depositMethod,
            depositNote: depositNote.trim(),
          },
        };
        var addDepositResponse = await axios.put(
          `${apiBaseUrl}/api/tables/edit-table`,
          addDeposit
        );
        console.log("addDepositResponse", addDepositResponse);
      } else {
        // Make sure the new table does NOT have a deposit
        const clearDeposit = {
          tableId: newTableId,
          hasDeposit: false,
          deposit: {
            depositAmount: "0.00",
            depositMethod: "Paynow",
            depositNote: "",
          },
        };
        var addDepositResponse = await axios.put(
          `${apiBaseUrl}/api/tables/edit-table`,
          clearDeposit
        );
        console.log("clearDepositResponse", addDepositResponse);
      }

      if (response.status === 200) {
        setNewSelectedTableModal(false);
      } else {
        console.error("Failed to update table:", response.data);
      }

      if (
        removeDepositResponse.status === 200 &&
        addDepositResponse.status === 200
      ) {
        setHasDeposit(false);
        setDeposit("0.00");
        setDepositMethod("Paynow");
        setDepositNote("");
        // window.location.reload();
      } else {
        console.error("Failed to update table:", response.data);
      }

      //print relocate table chit
      const relocatTablePayload = {
        selectedTableOrders: selectedTableOrders,
        order_tablenumber: tableNumber,
        newTablenumber: selectedNewTableNumber
      }
      const printRelocateTableResponse = await axios.post(`${apiBaseUrl}/api/printRelocateTable`, relocatTablePayload);
      if (printRelocateTableResponse.data.success) {
        message.success("Relocate table chit printed successfully!");
      } else {
        message.error("Failed to print relocate table chit!");
      }

    } catch (error) {
      console.error("Error updating table:", error);
    }
  };

  const handleNewTableDropdownVisibleChange = (open) => {
    setNewTableOpen(open);
  };

  const editDeposit = async () => {
    setDeposit(parseFloat(deposit).toFixed(2));
    console.log("depositId", depositId);
    try {
      const payload = {
        depositId: depositId,
        depositAmount: deposit,
        depositMethod: depositMethod,
      };

      const response = await axios.put(
        `${apiBaseUrl}/api/deposit/edit-deposit`,
        payload
      );

      if (response.status === 200) {
        setShowModifyDeposit(false);
      } else {
        console.error("Failed to update deposit:", response.data);
      }
    } catch (error) {
      console.error("Error updating deposit:", error);
    }
  };

  const createDeposit = async () => {
    setDeposit(parseFloat(deposit).toFixed(2));
    try {
      const payload = {
        depositAmount: deposit,
        depositMethod: depositMethod,
      };

      const response = await axios.post(
        `${apiBaseUrl}/api/deposit/create-deposit`,
        payload
      );

      if (response.status === 200) {
        setNeedCreateDeposit(false);
        setShowModifyDeposit(false);
      } else {
        console.error("Failed to create deposit:", response.data);
      }
    } catch (error) {
      console.error("Error updating deposit:", error);
    }
  };

  const handleVoidDeposit = async () => {
    const result = await Swal.fire({
      title: "Warning",
      text: "Are you sure you want to void this deposit?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    });

    if (result.isConfirmed) {
      voidDeposit();
    }
  };

  const voidDeposit = async () => {
    try {
      let userId;
      if (settings.isAccessKeyNeeded) {

        const operator = await accessKeyModalRef.current?.show();
        if (!operator) {
          return;
        } else {
          userId = operator?.user?.userId;
        }
      } else {
        userId = localStorage.getItem("userId");
      }

      console.log('userId: ', userId);

      const payload = {
        tableId: table._id,
        hasDeposit: false,
        deposit: {
          depositAmount: "0.00",
          depositMethod: "Paynow",
          depositNote: "",
        },
      };

      const response = await axios.put(
        `${apiBaseUrl}/api/tables/edit-table`,
        payload
      );

      if (response.status === 200) {
        printVoidDepositChip(userId || '', table.table_number, deposit, depositMethod, depositNote);

        setHasDeposit(false);
        setDeposit("0.00");
        setDepositMethod("Paynow");
        setDepositNote("");


      } else {
        console.error("Failed to update table:", response.data);
      }
    } catch (error) {
      console.error("Error updating table:", error);
    }
  };

  useEffect(() => {
    if (depositNote === "") {
      setDepositKey([]);
    }
  }, [depositNote]);

  // console.log("isBusy ", isBusy);

  // Helper to check if any modal is open
  const anyModalOpen = open || editOrderVisible || qrVisible || orderReceiptVisible || newSelectedTableModal || depositModalVisible || showModifyDeposit;

  // Only use incrementModal and decrementModal for modal blur
  useEffect(() => {
    if (open) {
      incrementModal();
      return () => decrementModal();
    }
  }, [open, incrementModal, decrementModal]);
  useEffect(() => {
    if (editOrderVisible) {
      incrementModal();
      return () => decrementModal();
    }
  }, [editOrderVisible, incrementModal, decrementModal]);
  useEffect(() => {
    if (qrVisible) {
      incrementModal();
      return () => decrementModal();
    }
  }, [qrVisible, incrementModal, decrementModal]);
  useEffect(() => {
    if (orderReceiptVisible) {
      incrementModal();
      return () => decrementModal();
    }
  }, [orderReceiptVisible, incrementModal, decrementModal]);
  useEffect(() => {
    if (newSelectedTableModal) {
      incrementModal();
      return () => decrementModal();
    }
  }, [newSelectedTableModal, incrementModal, decrementModal]);
  useEffect(() => {
    if (depositModalVisible) {
      incrementModal();
      return () => decrementModal();
    }
  }, [depositModalVisible, incrementModal, decrementModal]);
  useEffect(() => {
    if (showModifyDeposit) {
      incrementModal();
      return () => decrementModal();
    }
  }, [showModifyDeposit, incrementModal, decrementModal]);

  const isDeliveredEnabled = !settings.deliverDisableToggle;
  const footerButtonStyle = isDeliveredEnabled
    ? {
      borderRadius: "8px",
      fontWeight: "700",
      height: "36px",
      padding: "0 20px",
      fontSize: "16px",
      border: "2px solid #e5e7eb",
      backgroundColor: "#ffffff",
      color: "#374151",
      transition: "all 0.2s ease",
    }
    : {
      borderRadius: "8px",
      fontWeight: "700",
      height: "45px",
      padding: "0 20px",
      fontSize: "20px",
      border: "2px solid #e5e7eb",
      backgroundColor: "#ffffff",
      color: "#374151",
      transition: "all 0.2s ease",
    };

  const footerButtonDisabledStyle = {
    backgroundColor: "#f3f4f6", // light gray
    color: "#bdbdbd",           // muted text
    border: "2px solid #e5e7eb",
    cursor: "not-allowed"
  };

  // Compact style for when Delivered is enabled
  const compactFooterButtonStyle = {
    borderRadius: "8px",
    fontWeight: "700",
    height: "40px",
    padding: "0 15px",
    fontSize: "18px",
    border: "2px solid #e5e7eb",
    backgroundColor: "#ffffff",
    color: "#374151",
    transition: "all 0.2s ease",
  };

  // Use compact style if Delivered is enabled
  const useCompact = !settings.deliverDisableToggle;
  const buttonStyle = useCompact ? compactFooterButtonStyle : footerButtonStyle;

  const getWifiId = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/api/settings/get-settings`);
      const { wifiId, wifiPassword } = response.data;
      setWifiId(wifiId);
      setWifiPassword(wifiPassword);
      console.log({ wifiId, wifiPassword });
    } catch (error) {
      console.error("Failed to fetch info:", error);
    }
  };

  return (
    <div className="table-list-page">
      <div className="card-size">
        <Card
          className={
            table.table_status
              ? isBusy
                ? "busy"
                : "available"
              : "unavailable"
          }
          hoverable
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "130px",
            width: "120px",
            alignItems: "center",
            textAlign: "center",
            marginBottom: "14px",
            borderRadius: "12px",
            backgroundColor: table.table_status
              ? isBusy
                ? "#fef2f2" // light red for busy
                : "#f0fdf4" // light green for available
              : "#f8f9fa",
            boxShadow: table.table_status
              ? "0 4px 16px rgba(0, 0, 0, 0.08)"
              : "0 2px 8px rgba(0, 0, 0, 0.04)",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            position: "relative",
            border: table.table_status
              ? isBusy
                ? "2px solid #fecaca" // red for busy
                : "2px solid #7dee7d" // green for available
              : "2px solid #e9ecef",
            cursor: table.table_status ? "pointer" : "not-allowed",
            overflow: "hidden",
          }}
          onClick={
            table.table_status ? () => showModal(table.table_number) : null
          }
          onMouseEnter={(e) => {
            if (table.table_status) {
              e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.12)";
            }
          }}
          onMouseLeave={(e) => {
            if (table.table_status) {
              e.currentTarget.style.boxShadow = "0 4px 16px rgba(0, 0, 0, 0.08)";
            }
          }}
        >
          {/* Status Indicator Bar */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "4px",
              backgroundColor: table.table_status
                ? isBusy
                  ? "#ef4444"
                  : "#7dee7d" // green for available
                : "#9ca3af",
            }}
          />

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            {/* Badge Row */}
            <div className="badge-row" style={{ marginBottom: "2px" }}>
              <span className={`badge-dot-pos ${countOrder > 0 ? 'order' : 'gray'}`}>{countOrder}</span>
              <span className={`badge-dot-pos ${countKitchen > 0 ? 'kitchen' : 'gray'}`}>{countKitchen}</span>
              <span className={`badge-dot-pos ${countDelivered > 0 ? 'delivered' : 'gray'}`}>{countDelivered}</span>
            </div>

            {/* Table Number */}
            <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <div style={{
                fontSize: "12px",
                fontWeight: "600",
                color: "rgba(0, 0, 0, 0.6)",
                marginBottom: "2px",
                textTransform: "uppercase",
                letterSpacing: "0.5px"
              }}>
              </div>
              <div style={{
                fontSize: table.table_number.length > 16 ? "16px" : table.table_number.length > 10 ? "20px" : "28px",
                fontWeight: "500",
                color: "rgba(0, 0, 0, 0.7)",
                lineHeight: "1.1",
                textAlign: "center",
              }}>
                {table.table_number}
              </div>
            </div>

            {/* Status Badge */}
            <div
              className={`status-badge-pos ${isBusy ? 'busy' : 'available'}`}
              style={{ marginTop: '10px', fontSize: '12px', padding: '3px 10px' }}
            >
              <span className="status-dot" />
              {isBusy ? 'BUSY' : 'AVAILABLE'}
            </div>
          </div>
        </Card>
      </div>

      <Modal
        open={open}
        title={
          <div>
            <div className="tablePadding" style={{
              fontSize: "24px",
              fontWeight: "700",
              color: "#1f2937",
              marginBottom: "8px",
              textAlign: "center"
            }}>
              {`Table ${table.table_number}`}
            </div>
            <CloseButton onClick={handleCancel} />
            {/* Control Panel */}
            <div className="showButtonOnTop" style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              flexWrap: "wrap",
            }}>
              {/* Toggle Select All/Deselect All Button */}
              <Button
                type="default"
                size="small"
                onClick={() => {
                  const allSelected = Array.isArray(selectedTableOrders) && orders.length > 0 && orders.every((order) => selectedTableOrders.includes(order.oid));
                  if (allSelected) {
                    // Deselect all
                    localStorage.setItem("selectedTableOrders", null);
                    setSelectedTableOrders([]);
                    localStorage.setItem("selectedTableOrders", JSON.stringify([]));
                    setActiveKeys([]); // Collapse all panels
                  } else {
                    // Select all
                    const allOrderIds = orders.map((order) => order.oid);
                    setSelectedTableOrders(allOrderIds);
                    localStorage.setItem("selectedTableOrders", JSON.stringify(allOrderIds));
                    setActiveKeys(allOrderIds); // Expand all panels
                  }
                }}
                disabled={orders.length === 0}
                style={{
                  borderRadius: "8px",
                  fontWeight: "700",
                  height: "36px",
                  padding: "0 16px",
                  border: "2px solid #e5e7eb",
                  backgroundColor: "#ffffff",
                  color: "#374151",
                  ...(orders.length === 0 ? footerButtonDisabledStyle : {})
                }}
              >
                {Array.isArray(selectedTableOrders) && orders.length > 0 && orders.every((order) => selectedTableOrders.includes(order.oid)) ? "Deselect All" : "Select All"}
              </Button>

              <Button
                type="default"
                size="small"
                onClick={handleCollapseToggle}
                disabled={orders.length === 0}
                style={{
                  borderRadius: "8px",
                  fontWeight: "700",
                  height: "36px",
                  padding: "0 16px",
                  border: "2px solid #e5e7eb",
                  backgroundColor: "#ffffff",
                  color: "#374151",
                  ...(orders.length === 0 ? footerButtonDisabledStyle : {})
                }}
              >
                {areAllCollapsed ? "Expand All" : "Collapse All"}
              </Button>

              {/* Order Status Summary */}
              <div className="BadgeCountDesign" style={{
                display: "flex",
                gap: "8px",
                marginLeft: "auto",
                borderRadius: "12px",
              }}>
                <Tooltip title="Pending Orders">
                  <Badge
                    className="BadgePerCountDesign"
                    count={show ? countOrder : 0}
                    showZero
                    style={{
                      ...getBadgeStyle(show ? countOrder : 0, "#ef4444"),
                      fontSize: "12px",
                      fontWeight: "700",
                      borderRadius: "10px",
                      minWidth: "24px",
                      height: "24px",
                      lineHeight: "24px",
                      boxShadow: "0 2px 4px rgba(239, 68, 68, 0.3)",
                    }}
                  />
                </Tooltip>
                <Tooltip title="In Kitchen">
                  <Badge
                    className="BadgePerCountDesign"
                    count={show ? countKitchen : 0}
                    showZero
                    style={{
                      ...getBadgeStyle(show ? countKitchen : 0, "#f59e0b"),
                      fontSize: "12px",
                      fontWeight: "700",
                      borderRadius: "10px",
                      minWidth: "24px",
                      height: "24px",
                      lineHeight: "24px",
                      boxShadow: "0 2px 4px rgba(245, 158, 11, 0.3)",
                    }}
                  />
                </Tooltip>
                <Tooltip title="Delivered">
                  <Badge
                    className="BadgePerCountDesign"
                    count={show ? countDelivered : 0}
                    showZero
                    style={{
                      ...getBadgeStyle(show ? countDelivered : 0, "#10b981"),
                      fontSize: "12px",
                      fontWeight: "700",
                      borderRadius: "10px",
                      minWidth: "24px",
                      height: "24px",
                      lineHeight: "24px",
                      boxShadow: "0 2px 4px rgba(16, 185, 129, 0.3)",
                    }}
                  />
                </Tooltip>
              </div>
            </div>
          </div>
        }
        onOk={handleOk}
        onCancel={handleCancel}
        className="fixed-footer"
        footer={[
          // Deposit Button
          <Button
            key="deposit"
            type="default"
            onClick={showDepositModal}
            style={false ? { ...buttonStyle, ...footerButtonDisabledStyle } : buttonStyle}
          // Deposit is never disabled, so just use buttonStyle
          >
            Deposit
          </Button>,

          <Button
            type="default"
            onClick={printDepositChip}
            disabled={!hasDeposit}
            style={!hasDeposit ? { ...buttonStyle, ...footerButtonDisabledStyle } : buttonStyle}
          >
            Print Deposit
          </Button>,

          // Relocate Table Button
          <Button
            key="relocateTable"
            type="default"
            disabled={
              Array.isArray(selectedTableOrders) &&
              !orders.some((order) => selectedTableOrders.includes(order.oid))
            }
            onClick={() => {
              setNewSelectedTableModal(true);
            }}
            style={
              Array.isArray(selectedTableOrders) &&
                !orders.some((order) => selectedTableOrders.includes(order.oid))
                ? { ...buttonStyle, ...footerButtonDisabledStyle }
                : buttonStyle
            }
          >
            Relocate Table
          </Button>,

          // Show QR Button
          <Button
            key="showQR"
            type="default"
            onClick={() => showQrModal(tableNumber)}
            style={buttonStyle}
          >
            Show QR
          </Button>,

          // Order Button
          <Button
            key="back"
            onClick={async () => {
              try {
                let userId;
                if (settings.isAccessKeyNeeded) {

                  const operator = await accessKeyModalRef.current?.show();
                  if (!operator) {
                    return;
                  } else {
                    userId = operator?.user?.userId;
                  }
                } else {
                  userId = localStorage.getItem("userId");
                }

                console.log('userId: ', userId);


                localStorage.setItem('userId', userId);
                navigate('/orders?table=' + tableNumber);

                // const token = await handleAdminToken(operator?.user?.userId);
                // if (token) {
                //   setTimeout(() => {
                //     window.open(
                //       `${apiEndUserBaseUrl}/shop?table=${table.table_number}&token=${token}`,
                //       "_blank",
                //       "width=1920,height=1080,left=0,top=0"
                //     );
                //   });
                // }

              } catch (error) {
                Swal.fire({
                  icon: "error",
                  title: "Failed to open order page. Please try again.",
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                });
              }
            }}
            style={buttonStyle}
          >
            Order
          </Button>,

          // Print to Kitchen Button
          <Button
            type={(!Array.isArray(selectedTableOrders) || selectedTableOrders.length === 0) ? "default" : "primary"}
            onClick={() => {
              if (!Array.isArray(selectedTableOrders) || selectedTableOrders.length === 0) {
                message.warning('Please select at least one order to print.');
                return;
              }
              setOrderReceiptVisible(true);
              setOrderReceiptSelectedOrders(selectedTableOrders);
            }}
            disabled={
              !Array.isArray(selectedTableOrders) ||
              selectedTableOrders.length === 0
            }
            style={
              !Array.isArray(selectedTableOrders) || selectedTableOrders.length === 0
                ? { ...buttonStyle, ...footerButtonDisabledStyle }
                : buttonStyle
            }
          >
            Print
          </Button>,

          // Delivered Button
          !settings.deliverDisableToggle && (
            <Button
              type={(!Array.isArray(selectedTableOrders) || selectedTableOrders.length === 0) ? "default" : "primary"}
              style={
                !Array.isArray(selectedTableOrders) || selectedTableOrders.length === 0
                  ? { ...buttonStyle, ...footerButtonDisabledStyle }
                  : buttonStyle
              }
              onClick={() => {
                if (!Array.isArray(selectedTableOrders) || selectedTableOrders.length === 0) {
                  message.warning('Please select at least one order to mark as delivered.');
                  return;
                }
                const result = filterBySelectedTableOrders(selectedTableOrders);
                if (result) {
                  handleEditOrderStatus("Receive", selectedTableOrders);
                }
                else {
                  message.error("One or more orders are not eligible for delivery.");
                  return;
                }
              }}
              disabled={
                !Array.isArray(selectedTableOrders) ||
                selectedTableOrders.length === 0
              }
            >
              Delivered
            </Button>
          ),

          // Checkout Button
          <Button
            key="submit"
            type={
              orders && orders.some((order) => order.order_status)
                ? "primary"
                : "default"
            }
            danger={
              orders && orders.some((order) => order.order_status)
                ? true
                : false
            }
            loading={loading}
            onClick={() => handleCheckoutClick(table.table_number)}
            disabled={
              orders &&
                orders.some(
                  (order) => order.order_status
                )
                ? false
                : true
            }
            style={
              orders && orders.some((order) => order.order_status)
                ? buttonStyle
                : { ...buttonStyle, ...footerButtonDisabledStyle }
            }
          >
            Checkout
          </Button>,
        ]}
      >
        {/* Add Here (Deposit UI) */}
        {hasDeposit && (
          <Collapse
            style={{ marginBottom: "20px" }}
            expandIcon={() => null}
            activeKey={depositKey}
            onChange={(keys) => {
              if (depositNote !== "") {
                setDepositKey(keys);
              }
            }}
          >
            <span>
              <Badge.Ribbon color="gray" />
            </span>
            <Panel
              key="depositPanel"
              className="panelDesign"
              header={
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "12px 0",
                  width: "100%"
                }}>
                  <strong style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#1f2937",
                    display: "block",
                    marginBottom: "4px"
                  }}>
                    Deposit {symbol}{deposit} by {[depositMethod]}
                  </strong>
                  <div style={{
                    marginLeft: "auto",
                    display: "flex",
                    alignItems: "center",
                    gap: "12px"
                  }}>
                    <Tooltip title="Void Deposit">
                      <DeleteOutlined
                        style={{
                          color: "#ef4444",
                          fontSize: "20px",
                          cursor: "pointer",
                          padding: "6px",
                          borderRadius: "6px",
                          transition: "all 0.2s ease"
                        }}
                        onMouseOver={e => {
                          e.target.style.backgroundColor = "#fef2f2";
                          e.target.style.color = "#dc2626";
                        }}
                        onMouseOut={e => {
                          e.target.style.backgroundColor = "transparent";
                          e.target.style.color = "#ef4444";
                        }}
                        onClick={handleVoidDeposit}
                      />
                    </Tooltip>
                    <Badge className="badgeStyle" status="success" />
                  </div>
                </div>
              }
              style={{
                marginBottom: "16px",
                borderRadius: "12px",
                border: "1px solid #e5e7eb",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                overflow: "hidden",
                backgroundColor: "#f8fafc"
              }}
            >
              {depositNote && (
                <p style={{ padding: "8px 0", fontSize: "14px", color: "#374151" }}>
                  <strong>Note:</strong> {depositNote}
                </p>
              )}
            </Panel>
          </Collapse>
        )}

        <Collapse
          activeKey={activeKeys}
          // onChange={onChange}
          onChange={handlePanelChange}
        // collapsible="icon"
        >
          <span //style={{ marginLeft: '10px' }}
          >
            {statusBadge((order) => order.order_progressstatus)}
          </span>

          {orders.map((order) => {
            // const totalWithTaxes = calculateTotalWithTaxes(order); // Calculate total with taxes for the current order
            // Only render the Panel if the total with taxes is greater than 0
            // if (totalWithTaxes > 0) {
            if (order.order_items && order.order_items.length > 0) {
              return (
                <Panel
                  className="panelDesign"
                  header={
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "12px 0",
                      width: "100%",
                      gap: "16px"
                    }}>
                      <input
                        type="checkbox"
                        checked={selectedTableOrders.includes(order.oid)}
                        onChange={(e) => handleCheckboxChange(e, order.oid)}
                        style={{
                          marginRight: "16px",
                          transform: "scale(1.2)",
                          accentColor: "#3b82f6"
                        }}
                      />
                      <div style={{ flex: 1 }}>
                        <strong style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          color: "#1f2937",
                          display: "block",
                          marginBottom: "4px"
                        }}>
                          Order #{order.oid}
                        </strong>
                        <div style={{
                          fontSize: "12px",
                          color: "#6b7280",
                          fontWeight: "500"
                        }}>
                          {new Date(order.order_createdAt).toLocaleString()}
                        </div>
                      </div>
                      {/* Flex row for Void button and status badge with fixed badge width */}
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {activeKeys.includes(order.oid) && (
                          <Tooltip title="Void Order">
                            <DeleteOutlined
                              style={{
                                color: "#ef4444",
                                fontSize: "20px",
                                cursor: "pointer",

                                padding: "6px",
                                borderRadius: "6px",
                                transition: "all 0.2s ease"
                              }}
                              onMouseOver={e => {
                                e.target.style.backgroundColor = "#fef2f2";
                                e.target.style.color = "#dc2626";
                              }}
                              onMouseOut={e => {
                                e.target.style.backgroundColor = "transparent";
                                e.target.style.color = "#ef4444";
                              }}
                              onClick={() => voidEntireOrderConfirmation(order._id, currentUser)}
                            />
                          </Tooltip>
                        )}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "6px 12px",
                            borderRadius: "20px",
                            minWidth: "120px",
                            justifyContent: "center",
                            backgroundColor: order.order_progressstatus === ""
                              ? "#fef2f2"
                              : order.order_progressstatus === "Kitchen"
                                ? "#fffbeb"
                                : order.order_progressstatus === "Receive"
                                  ? "#f0fdf4"
                                  : "#f8fafc",
                            border: `2px solid ${order.order_progressstatus === ""
                              ? "#fecaca"
                              : order.order_progressstatus === "Kitchen"
                                ? "#fed7aa"
                                : order.order_progressstatus === "Receive"
                                  ? "#bbf7d0"
                                  : "#e2e8f0"
                              }`
                          }}
                        >
                          <div style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor: order.order_progressstatus === ""
                              ? "#ef4444"
                              : order.order_progressstatus === "Kitchen"
                                ? "#f59e0b"
                                : order.order_progressstatus === "Receive"
                                  ? "#10b981"
                                  : "#9ca3af",
                            marginRight: "8px",
                            boxShadow: "0 0 0 2px rgba(0, 0, 0, 0.1)"
                          }} />
                          <span style={{
                            color: order.order_progressstatus === ""
                              ? "#dc2626"
                              : order.order_progressstatus === "Kitchen"
                                ? "#d97706"
                                : order.order_progressstatus === "Receive"
                                  ? "#059669"
                                  : "#6b7280",
                            fontWeight: "700",
                            fontSize: "11px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px"
                          }}>
                            {order.order_progressstatus === ""
                              ? "Pending"
                              : order.order_progressstatus === "Kitchen"
                                ? "In Kitchen"
                                : order.order_progressstatus === "Receive"
                                  ? "Delivered"
                                  : "Unknown"}
                          </span>
                        </div>
                      </div>
                    </div>
                  }
                  key={order.oid}
                  style={{
                    marginBottom: "16px",
                    borderRadius: "12px",
                    border: "1px solid #e5e7eb",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                    overflow: "hidden"
                  }}
                >
                  <Table
                    bordered
                    pagination={false}
                    size="small"
                    style={{
                      borderRadius: "8px",
                      overflow: "hidden",
                      border: "1px solid #e5e7eb"
                    }}
                    className="order-table"
                    columns={[
                      {
                        title: "No",
                        key: "index",
                        width: 60,
                        align: "center",
                        render: (text, record, recordIndex) => (
                          <span style={{
                            fontWeight: "600",
                            color: "#374151",
                            fontSize: "13px"
                          }}>
                            {recordIndex + 1}
                          </span>
                        ),
                      },
                      {
                        title: "Status",
                        dataIndex: "product.itemDeliverStatus",
                        render: (itemDeliverStatus, record) => {
                          let displayText = "";
                          let color = "";
                          let backgroundColor = "";
                          let borderColor = "";

                          // Check individual item delivery status first
                          if (record.product && record.product.itemDeliverStatus === true) {
                            displayText = "Delivered";
                            color = "green";
                            backgroundColor = "#f6ffed";
                            borderColor = "#b7eb8f";
                          } else if (order.order_progressstatus === "") {
                            displayText = "Ordered";
                            color = "#d4380d";
                            backgroundColor = "#fff2e8";
                            borderColor = "#ffbb96";
                          } else if (order.order_progressstatus === "Kitchen") {
                            displayText = "Sent to Kitchen";
                            color = "#a29659";
                            backgroundColor = "#fffbe6";
                            borderColor = "#ffe58f";
                          } else if (order.order_progressstatus === "Receive") {
                            displayText = "Delivered";
                            color = "green";
                            backgroundColor = "#f6ffed";
                            borderColor = "#b7eb8f";
                          }

                          return (
                            <Tag
                              style={{
                                color: color,
                                backgroundColor: backgroundColor,
                                borderColor: borderColor,
                                fontSize: "14px"
                              }}
                            >
                              {displayText}
                            </Tag>
                          );
                        },
                      },
                      {
                        title: "Food Name",
                        dataIndex: "product",
                        render: (product) => (
                          <div>
                            <span style={{
                              fontWeight: "600",
                              color: "#1f2937",
                              fontSize: "18px",
                              display: "block"
                            }}>
                              {product.name}
                            </span>
                            {product.addOns && product.addOns.length > 0 && (
                              <div style={{
                                fontSize: "13px",
                                color: "#6b7280",
                                marginTop: "4px"
                              }}>
                                + {product.addOns.length} add-on(s)
                              </div>
                            )}
                          </div>
                        ),
                      },
                      {
                        title: "Qty",
                        dataIndex: "quantity",
                        width: 80,
                        align: "center",
                        render: (quantity) => (
                          <span style={{
                            fontWeight: "700",
                            color: "#ffffff",
                            backgroundColor: "#3b82f6",
                            padding: "4px 8px",
                            borderRadius: "12px",
                            fontSize: "12px",
                            minWidth: "24px",
                            display: "inline-block",
                            textAlign: "center"
                          }}>
                            {quantity}
                          </span>
                        ),
                      },
                      {
                        title: "Sub Menu",
                        dataIndex: "product",
                        render: (product) => {
                          if (!product.addOns || product.addOns.length === 0) {
                            return null;
                          }

                          const groupedSubMenu = product.addOns.reduce(
                            (acc, item) => {
                              if (!acc[item.group]) {
                                acc[item.group] = [];
                              }
                              acc[item.group].push(item);
                              return acc;
                            },
                            {}
                          );

                          return (
                            <ul>
                              {Object.entries(groupedSubMenu).map(
                                ([group, items]) => (
                                  <li key={group}>
                                    <strong>{group}</strong>
                                    <ul>
                                      {items.map((item, index) => (
                                        <li key={index}>
                                          {item.name}
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                )
                              )}
                            </ul>
                          );
                        },
                      },
                      {
                        title: "Remark",
                        dataIndex: "remarks",
                        render: (remarks) => remarks,
                      },
                      {
                        title: "Actions",
                        dataIndex: "order.order_progressstatus",
                        width: 120,
                        align: "center",
                        render: (order_progressstatus, record) => {
                          return (
                            <div className="actions-column" style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "8px"
                            }}>
                              <Tooltip title="Print Item">
                                <PrinterOutlined
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px", // Increased from 16px
                                    color: "#3b82f6",
                                    padding: "8px", // Increased from 6px
                                    borderRadius: "8px", // Increased from 6px
                                    transition: "all 0.2s ease"
                                  }}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor = "#eff6ff";
                                    e.target.style.color = "#1d4ed8";
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor = "transparent";
                                    e.target.style.color = "#3b82f6";
                                  }}
                                  onClick={() => {
                                    printSingleItem(order, record);
                                  }}
                                />
                              </Tooltip>

                              <Tooltip title="Edit Item">
                                <EditOutlined
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px",
                                    color: "#f59e0b",
                                    padding: "8px",
                                    borderRadius: "8px",
                                    transition: "all 0.2s ease"
                                  }}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor = "#fffbeb";
                                    e.target.style.color = "#d97706";
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor = "transparent";
                                    e.target.style.color = "#f59e0b";
                                  }}
                                  onClick={() => {
                                    if (order.order_progressstatus === "") {
                                      handleEditOrder(record);
                                      setOrder(order);
                                    }
                                  }}
                                />
                              </Tooltip>

                              <Tooltip title="Void Item">
                                <DeleteOutlined
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "20px", // Increased from 16px
                                    color: "#ef4444",
                                    padding: "8px", // Increased from 6px
                                    borderRadius: "8px", // Increased from 6px
                                    transition: "all 0.2s ease"
                                  }}
                                  onMouseOver={(e) => {
                                    e.target.style.backgroundColor = "#fef2f2";
                                    e.target.style.color = "#dc2626";
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.backgroundColor = "transparent";
                                    e.target.style.color = "#ef4444";
                                  }}
                                  onClick={async () => {
                                    // Build voidReasonOptions with all 'Other' at the bottom, prefix keys with 'r_'
                                    let voidReasons = Array.isArray(settings.voidReasons) ? [...settings.voidReasons] : [];
                                    const otherReasons = voidReasons.filter(r => r.reason.trim().toLowerCase() === 'other');
                                    voidReasons = voidReasons.filter(r => r.reason.trim().toLowerCase() !== 'other');
                                    voidReasons = [...voidReasons, ...otherReasons];
                                    const voidReasonOptions = {};
                                    voidReasons.forEach(r => { voidReasonOptions[`r_${r.id}`] = r.reason; });
                                    const { value: reasonResult, isConfirmed } =
                                      await Swal.fire({
                                        title: "Void Item",
                                        text: "Are you sure you want to void this item?",
                                        input: "select",
                                        inputLabel: "Reason for voiding",
                                        inputOptions: voidReasonOptions,
                                        inputPlaceholder: "Select a reason",
                                        inputValidator: (value) => {
                                          if (!value) {
                                            return "You must select a reason!";
                                          }
                                        },
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#ef4444",
                                        cancelButtonColor: "#6b7280",
                                        confirmButtonText: "Void Item",
                                        cancelButtonText: "Cancel",
                                        preConfirm: async (selectedKey) => {
                                          const selectedId = selectedKey.startsWith('r_') ? selectedKey.slice(2) : selectedKey;
                                          const selectedReason = voidReasons.find(r => r.id === selectedId);
                                          if (selectedReason && selectedReason.reason.trim().toLowerCase() === 'other') {
                                            const { value: remark, isConfirmed: isOtherConfirmed } = await Swal.fire({
                                              title: "Other Reason",
                                              input: "text",
                                              inputLabel: "Please specify the reason (optional)",
                                              inputPlaceholder: "Enter your reason",
                                              showCancelButton: true,
                                              confirmButtonText: "OK",
                                            });
                                            if (!isOtherConfirmed) return false; // Cancel closes all
                                            return { id: selectedId, text: remark ? remark : selectedReason.reason };
                                          }
                                          return { id: selectedId, text: selectedReason?.reason || "" };
                                        }
                                      });

                                    if (isConfirmed && reasonResult && reasonResult.text) {
                                      handleDeleteOrder(order, record, reasonResult.text);
                                    }
                                  }}
                                />
                              </Tooltip>
                            </div>
                          );
                        },
                      },
                    ]}
                    dataSource={order.order_items || []}
                  />
                </Panel>
              );
            }
          })}
        </Collapse>

        <br></br>

        <Collapse
          activeKey={activeKeys}
          onChange={handlePanelChange}
        // collapsible="icon"
        >
          {orders
            .filter(
              (order) =>
                order.void_items &&
                order.void_items.length > 0 &&
                order.order_voidstatus == false
            )
            .map((order) => {
              return (
                <Panel
                  className="panelDesign"
                  style={{ backgroundColor: "#b9b9b9" }}
                  header={
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <strong>Order ID: #{order.oid}</strong>
                      <div className="badgeStyle">
                        <span
                          style={{
                            backgroundColor: "#FFEAEB",
                            color: "#ff1a1a",
                            borderRadius: "8px",
                            fontWeight: 700,
                            fontSize: "11px",
                            padding: "4px 14px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >
                          Voided
                        </span>
                      </div>
                    </div>
                  }
                  key={order.oid}
                >
                  <Table
                    bordered
                    pagination={false}
                    size="small"
                    style={{
                      borderRadius: "8px",
                      overflow: "hidden"
                    }}
                    className="order-table"
                    columns={[
                      {
                        title: "No",
                        key: "index",
                        render: (text, record, recordIndex) => (
                          <span>{recordIndex + 1}</span>
                        ),
                      },
                      {
                        title: "Food Name",
                        dataIndex: "product",
                        render: (product) => product.name,
                      },
                      {
                        title: "Price (" + symbol + ")",
                        dataIndex: "product",
                        render: (product) =>
                          `${symbol} ${parseFloat(product.price).toFixed(2)}`,
                      },
                      {
                        title: "Quantity",
                        dataIndex: "quantity",
                        align: "center",
                        render: (quantity) => (
                          <span style={{
                            fontWeight: "700",
                            color: "#ffffff",
                            backgroundColor: "#3b82f6",
                            padding: "4px 8px",
                            borderRadius: "12px",
                            fontSize: "12px",
                            minWidth: "24px",
                            display: "inline-block",
                            textAlign: "center"
                          }}>
                            {quantity}
                          </span>
                        ),
                      },
                      {
                        title: "Sub Menu",
                        dataIndex: "product",
                        render: (product) => {
                          if (!product.addOns || product.addOns.length === 0) {
                            return null;
                          }

                          const groupedSubMenu = product.addOns.reduce(
                            (acc, item) => {
                              if (!acc[item.group]) {
                                acc[item.group] = [];
                              }
                              acc[item.group].push(item);
                              return acc;
                            },
                            {}
                          );

                          return (
                            <ul>
                              {Object.entries(groupedSubMenu).map(
                                ([group, items]) => (
                                  <li key={group}>
                                    <strong>{group}</strong>
                                    <ul>
                                      {items.map((item, index) => (
                                        <li key={index}>
                                          {item.name}
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                )
                              )}
                            </ul>
                          );
                        },
                      },

                      {
                        title: "Remark",
                        dataIndex: "remarks",
                        render: (remarks) => remarks,
                      },
                      {
                        title: "Void Reason",
                        dataIndex: "void_reason", // Ensure this matches the backend field name
                        render: (void_reason) => {
                          // Map backend reason codes to readable text
                          const reasonMap = {
                            hygiene_problem: "Hygiene Problem",
                            waiting_too_long: "Waiting Too Long",
                            wrong_item: "Wrong Item",
                            other: "Other",
                          };
                          return (
                            <Tag color="red">
                              {reasonMap[void_reason] || void_reason}
                            </Tag>
                          );
                        },
                      },
                    ]}
                    dataSource={order.void_items || []}
                  />
                </Panel>
              );
            })}
        </Collapse>

        <></>
      </Modal>

      <Modal
        open={editOrderVisible}
        title={
          <div>
            <CloseButton onClick={() => setEditOrderVisible(false)} />
            Edit Order
          </div>
        }
        onCancel={() => setEditOrderVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setEditOrderVisible(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={async () => {
              setIsSubmitted(true); // Trigger validation for null values
              // Show the modal if validation fails
              const validQuantity =
                currentOrder.quantity !== null &&
                currentOrder.quantity > 0 &&
                typeof currentOrder.quantity === "number";

              if (validQuantity) {
                // Proceed with the order update
                await handleUpdateOrder(currentOrder, order);
              } else {
                // If there's an issue with quantity, show an error and keep modal open
                message.error("Please fix the errors before submitting.");
                setEditOrderVisible(true);
              }
            }}
          >
            Save
          </Button>,
        ]}
      >
        {currentOrder && (
          <Form layout="vertical">
            <Form.Item
              label={<span className="custom-label-remark">Food Name</span>}
            >
              <Input disabled={true} value={currentOrder.product.name} />
            </Form.Item>

            <Form.Item
              label="Quantity"
              validateStatus={validateStatus}
              help={errorMsg}
              required
            >
              <InputNumber
                value={currentOrder.quantity}
                onChange={(value) => {
                  setCurrentOrder({ ...currentOrder, quantity: value });
                  if (isSubmitted) setIsSubmitted(false); // Reset submission state on new input
                }}
                style={{ width: "100%" }}
                className="no-spinner"
              />
            </Form.Item>

            <Form.Item
              label={<span className="custom-label-remark">Remark</span>}
            >
              <Input
                value={currentOrder.remarks}
                onChange={(e) =>
                  setCurrentOrder({ ...currentOrder, remarks: e.target.value })
                }
              />
            </Form.Item>

            <Form.Item label={<span>Sub Menu</span>}>
              {subMenu.length > 0 ? (
                <div>
                  {subMenu.map((submenu) => (
                    <div key={submenu.id}>
                      <h6>
                        {submenu.group}
                        {submenu.requirement === "required" && (
                          <span style={{ color: "red", marginLeft: "5px" }}>
                            *
                          </span>
                        )}
                      </h6>
                      <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                        {submenu.items.map((item) => (
                          <li key={item.id}>
                            {submenu.selection === "multiple" ? (

                              <Checkbox
                                value={item.name}
                                checked={
                                  currentOrder?.product?.addOns?.some(
                                    (addOn) => addOn.id === item.id
                                  ) || false
                                }
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  if (checked) {
                                    setCurrentOrder((prev) => ({
                                      ...prev,
                                      product: {
                                        ...prev.product,
                                        addOns: [
                                          ...(prev.product?.addOns || []),
                                          { ...item, group: submenu.group },
                                        ],
                                      },
                                    }));
                                  } else {
                                    setCurrentOrder((prev) => ({
                                      ...prev,
                                      product: {
                                        ...prev.product,
                                        addOns: (
                                          prev.product?.addOns || []
                                        ).filter(
                                          (addOn) => addOn.id !== item.id
                                        ),
                                      },
                                    }));
                                  }
                                }}
                              >
                                {item.name} ( + {symbol}{" "}
                                {parseFloat(item.price).toFixed(2)} )
                              </Checkbox>
                            ) : (
                              <Radio.Group
                                value={
                                  currentOrder?.product?.addOns?.find(
                                    (addOn) =>
                                      addOn.group === submenu.group &&
                                      addOn.id === item.id
                                  )?.id
                                }
                                onChange={(e) => {
                                  const selectedId = e.target.value;
                                  const selectedItem = submenu.items.find(
                                    (i) => i.id === selectedId
                                  );
                                  setCurrentOrder((prev) => ({
                                    ...prev,
                                    product: {
                                      ...prev.product,
                                      addOns: [
                                        ...(prev.product?.addOns || []).filter(
                                          (addOn) => addOn.group !== submenu.group
                                        ),
                                        {
                                          ...selectedItem,
                                          group: submenu.group,
                                        },
                                      ],
                                    },
                                  }));
                                }}
                              >
                                <Radio value={item.id}>
                                  {item.name} ( + {symbol}{" "}
                                  {parseFloat(item.price).toFixed(2)} )
                                </Radio>
                              </Radio.Group>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              ) : (
                <p>No submenus available for this product.</p>
              )}
            </Form.Item>
          </Form>
        )}
      </Modal>

      <Modal
        open={qrVisible}
        onOk={hideQrModal}
        onCancel={hideQrModal}
        className="qr-modal"
        footer={[
          <Button
            key="print"
            type="primary"
            onClick={() => printQrCode(`${table.table_number}`)}
          >
            Print
          </Button>,
        ]}
      >
        <div
          style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold" }}
        >
          QR Code
        </div>

        <div style={{ textAlign: "center" }}>
          {wifiId && wifiPassword && (
            <div
              style={{
                marginTop: "8px",
                display: "inline-grid",
                gridTemplateColumns: "auto auto",
                gap: "4px",
                textAlign: "left",
                fontSize: "14px",
                fontWeight: "bold"
              }}
            >
              <div>WiFi SSID</div>
              <div>: {wifiId}</div>
              <div>Password</div>
              <div>: {wifiPassword}</div>
            </div>
          )}
        </div>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          {/* <QRCode

            value={`${apiEndUserBaseUrl}/shop?table=${
             table.table_number
            }&token=${localStorage.getItem("adminToken")}`}
          /> */}
          <QRCode value={qrUrl} />
        </div>
        <div
          style={{
            textAlign: "center",
            marginTop: "10px",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          Table {QrTableNumber || table.table_number}
        </div>
      </Modal>

      <Modal
        open={orderReceiptVisible}
        zIndex={1001} // Set higher z-index for order receipt modal to appear on top
        onCancel={() => {
          setOrderReceiptVisible(false);
          setOrderReceiptSelectedOrders([]);
          localStorage.setItem("selectedTableOrders", []);
          localStorage.setItem("selectedSingleRecord", null);
        }}
        className="order-receipt-modal"
        footer={[
          <Button
            key="close"
            onClick={() => {
              setOrderReceiptVisible(false);
              setOrderReceiptSelectedOrders([]);
              localStorage.setItem("selectedTableOrders", []);
              localStorage.setItem("selectedSingleRecord", null);
            }}
          >
            Close
          </Button>,
          <Button
            key="print"
            type="primary"
            disabled={isPrinting}
            onClick={async () => {
              setIsPrinting(true);
              try {
                let result = await orderReceiptRef.current?.printOrderReceipt();
                console.warn("Printing order receipt...", result);
                if (result) {
                  Swal.fire({
                    title: "Order Chit Printed",
                    text: "Order chit has been printed successfully.",
                    icon: "success",
                    timerProgressBar: true,
                    timer: 3000,
                  });
                  handleEditOrderStatusKitchen("Kitchen", orderReceiptSelectedOrders);
                  setOrderReceiptVisible(false);
                  setOrderReceiptSelectedOrders([]);
                  localStorage.setItem("selectedTableOrders", []);
                  localStorage.setItem("selectedSingleRecord", null);
                } else {
                  // Show Swal with options
                  const { value } = await Swal.fire({
                    title: "Print Failed",
                    text: "Order chit printing failed. Do you want to reprint or update the status anyway?",
                    icon: "error",
                    showCancelButton: true,
                    showDenyButton: true,
                    denyButtonText: "Update Status",
                  });
                  if (value === true) {
                    // Reprint
                    result = await orderReceiptRef.current?.printOrderReceipt();
                    if (result) {
                      handleEditOrderStatusKitchen("Kitchen", orderReceiptSelectedOrders);

                    }
                  } else if (value === false) {
                    // Update status anyway
                    handleEditOrderStatusKitchen("Kitchen", orderReceiptSelectedOrders);
                  }
                  // Cancel does nothing
                }
              } catch (error) {
                console.error("Print failed:", error);
              } finally {
                setIsPrinting(false);
              }
            }}
          >
            Print to Kitchen
          </Button>
        ]}
        title={
          <div>
            Order Chit
            <CloseButton onClick={() => setOrderReceiptVisible(false)} />
          </div>
        }
      >
        <OrderReceipt
          ref={orderReceiptRef}
          orders={orders}
          selectedOrders={orderReceiptSelectedOrders}
          tableNumber={table.table_number}
        />
      </Modal>

      <AccessKeyModal ref={accessKeyModalRef} />

      {newSelectedTableModal && (
        <Modal
          title={
            <div>
              Please Select New Table
              <CloseButton onClick={() => setNewSelectedTableModal(false)} />
            </div>
          }
          open={newSelectedTableModal}
          className="relocate-modal"
          onCancel={() => setNewSelectedTableModal(false)}
          onOk={() => relocateTable()}
          width={300}
        >
          <Select
            onDropdownVisibleChange={handleNewTableDropdownVisibleChange}
            suffixIcon={
              newTableOpen ? <CaretUpOutlined /> : <CaretDownOutlined />
            }
            style={{ width: "100%" }}
            value={
              selectedNewTableNumber ||
              (newTableDatas[0] && newTableDatas[0].table_number)
            }
            onChange={(value) => setSelectedNewTableNumber(value)}
          >
            {newTableDatas.map((table) => (
              <Select.Option
                key={table.table_number}
                value={table.table_number}
              >
                {table.table_number}
              </Select.Option>
            ))}
          </Select>
        </Modal>
      )}

      {/* Add Here (Deposit) */}
      <Modal
        title={
          <div>
            Deposit
            <CloseButton onClick={() => hideDepositModal()} />
          </div>
        }
        open={depositModalVisible}
        className="deposit-modal"
        onCancel={() => hideDepositModal()}
        onOk={() => confirmDeposit()}
        width={600}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button type="default" onClick={() => setShowModifyDeposit(true)}>
              {needCreateDeposit ? "Create Deposit" : "Edit Deposit"}
            </Button>

            <div>
              <Button
                style={{ marginRight: 8 }}
                onClick={() => hideDepositModal()}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => confirmDeposit()}
                disabled={needCreateDeposit === true}
              >
                OK
              </Button>
            </div>
          </div>
        }
      >
        <Form>
          <Form.Item>
            <p style={{ fontSize: "16px" }}>
              Click "OK" to confirm the deposit of {symbol}
              {deposit} by {[depositMethod]}.
            </p>
            <Input
              type="text"
              value={depositNote}
              onChange={(e) => setDepositNote(e.target.value)}
              placeholder="Note"
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={
          <div>
            Create Deposit
            <CloseButton onClick={() => setShowModifyDeposit(false)} />
          </div>
        }
        open={showModifyDeposit}
        className="deposit-modal-wide"
        onCancel={() => setShowModifyDeposit(false)}
        onOk={() => (needCreateDeposit ? createDeposit() : editDeposit())}
        width={900}
      >
        <Form layout="vertical">
          <Form.Item
            name="Deposit"
            label={<>Deposit Amount ({symbol})</>}
            rules={[
              { required: true, message: "Please input the deposit amount!" },
              {
                validator: (_, value) => {
                  if (!value || parseFloat(value) >= 0) {
                    return Promise.resolve();
                  }
                  return Promise.reject("Deposit amount must be at least 0!");
                },
              },
            ]}
            initialValue={Number(deposit)}
          >
            <Input
              type="number"
              initialValue={Number(deposit)}
              value={Number(deposit)}
              onChange={(e) => setDeposit(e.target.value)}
            />
          </Form.Item>

          <Form.Item
            name="Deposit Method"
            label="Deposit Method"
            rules={[
              { required: true, message: "Please select a deposit method!" },
            ]}
            initialValue={depositMethod}
          >
            <div className="deposit">
              {paymentMethods.map(({ id, img, name }) => (
                <button
                  key={id}
                  onClick={() => setDepositMethod(id)}
                  disabled={id === ""}
                  className={`payment-button ${depositMethod === id ? "selected" : ""
                    } ${id === "" ? "disabled-button" : ""}`}
                >
                  {img && (
                    <img
                      src={img}
                      alt={`${name} Logo`}
                      className="payment-icon"
                    />
                  )}
                  <span>{name}</span>
                </button>
              ))}
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default TableList;
